import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "display"];

  connect() {
    // console.log("Madlibs controller connected");
    this.initializeDisplay();
  }

  initializeDisplay() {
    // Get all of the checked inputs within this controller's scope and update the display text
    const checkedInputs = this.inputTargets
      .filter((input) => input.checked)
      .map((input) => input.getAttribute("data-label"));

    if (checkedInputs.length === 0) {
      this.displayTarget.innerHTML = `<div class="w-24 h-7 p-1 bg-gray-200 rounded-sm animate-pulse"></div>`; // Maintain the same width as when options are selected
    } else if (checkedInputs.length === 1) {
      this.displayTarget.textContent = checkedInputs[0]; // Show the single checked input label
    } else {
      this.displayTarget.textContent = checkedInputs.join(", "); // Join multiple checked input values with a comma
    }
  }

  updateValue(event) {
    const input = event.target
      .closest("label")
      .querySelector("input[type='checkbox'], input[type='radio']");

    // const newValue = !input.checked;
    // // this.deselectAll();

    // input.checked = newValue;
    // Get all of the the checked inputs and update the display text

    // console.log(this.inputTargets);

    const checkedInputs = this.inputTargets
      .filter((input) => input.checked)
      .map((input) => input.getAttribute("data-label").toLowerCase());

    // console.log("Checked inputs:", checkedInputs);

    if (checkedInputs.length === 0) {
      this.displayTarget.innerHTML = `<div class="w-24 h-7 p-1 bg-gray-200 rounded-sm animate-pulse"></div>`; // Maintain the same width as when options are selected
    } else if (checkedInputs.length === 1) {
      this.displayTarget.textContent = checkedInputs[0]; // Show the single checked input label
    } else {
      this.displayTarget.textContent = checkedInputs.join(", "); // Join multiple checked input labels with a comma
    }
  }

  deselectAll() {
    // Deselect all checkboxes
    this.inputTargets.forEach((input) => {
      input.checked = false;
    });
    // Clear the display text
    this.displayTarget.textContent = "      ";
  }
}
